import {
  Building2,
  Heart,
  BookOpen,
  Database,
  Users,
  Wrench,
  Apple,
  Stethoscope,
  Activity,
  Brain,
  GraduationCap,
  Briefcase,
  DollarSign,
  Award,
  TrendingUp,
  Shield,
  FileCheck,
  Coins,
  Gift,
  Trophy,
  Music,
  Palette,
  Theater,
  PartyPopper,
} from "lucide-react";
import hostelCourtyardBg from "../../assets/hotels1.png";
import studentDiningBg from "../../assets/d15687f45a2e50e87171ba8dc84f15b191e4403f.png";
import sportsGroundBg from "../../assets/c064989bbc152298db49c00486354fd77b28a0d7.png";
import studentsStudyingBg from "../../assets/2b51ea662c961758c193da88f0b5129a3bd824de.png";
import digitalGovernanceBg from "../../assets/fb9e75c9ac0108832a3db54609ca5f4aa5dd7fdf.png";

export default function ProgramsPage() {
  const programs = [
    {
      title: "Hostel Modernisation Program",
      icon: <Building2 className="h-12 w-12" />,
      color: "from-[#7A1E1E] to-[#8B2E2E]",
      features: [
        {
          icon: <Wrench className="h-5 w-5" />,
          text: "Repairs, maintenance, renovation",
        },
        { icon: <Building2 className="h-5 w-5" />, text: "Dormitory upgrades" },
        { icon: <Heart className="h-5 w-5" />, text: "Clean drinking water" },
        {
          icon: <Shield className="h-5 w-5" />,
          text: "Sanitation & hygiene systems",
        },
        {
          icon: <Database className="h-5 w-5" />,
          text: "Digital MIS integration",
        },
      ],
    },
    {
      title: "Student Wellness & Nutrition Program",
      icon: <Heart className="h-12 w-12" />,
      color: "from-[#D4A017] to-[#B8900F]",
      features: [
        {
          icon: <Apple className="h-5 w-5" />,
          text: "Daily food-quality compliance",
        },
        { icon: <FileCheck className="h-5 w-5" />, text: "Nutrition mapping" },
        { icon: <Stethoscope className="h-5 w-5" />, text: "Health check-ups" },
        {
          icon: <Activity className="h-5 w-5" />,
          text: "Sports, yoga, fitness programs",
        },
        {
          icon: <Brain className="h-5 w-5" />,
          text: "Mental health & counselling support",
        },
      ],
    },
    {
      title: "Academic & Career Development Program",
      icon: <BookOpen className="h-12 w-12" />,
      color: "from-[#7A1E1E] to-[#8B2E2E]",
      features: [
        {
          icon: <GraduationCap className="h-5 w-5" />,
          text: "Coaching classes",
        },
        {
          icon: <BookOpen className="h-5 w-5" />,
          text: "CAT/CA/UPSC/JEE/NEET/CLAT preparation",
        },
        {
          icon: <DollarSign className="h-5 w-5" />,
          text: "Interest-free educational loans",
        },
        { icon: <Award className="h-5 w-5" />, text: "Scholarship support" },
        {
          icon: <Briefcase className="h-5 w-5" />,
          text: "Career guidance sessions",
        },
        {
          icon: <Users className="h-5 w-5" />,
          text: "Alumni mentorship networks",
        },
      ],
    },
    {
      title: "Digital Governance & Transparency Program",
      icon: <Database className="h-12 w-12" />,
      color: "from-[#D4A017] to-[#B8900F]",
      features: [
        { icon: <Shield className="h-5 w-5" />, text: "S-ARDA implementation" },
        { icon: <TrendingUp className="h-5 w-5" />, text: "SROI measurement" },
        { icon: <Coins className="h-5 w-5" />, text: "SIC credit issuance" },
        { icon: <Gift className="h-5 w-5" />, text: "HDT recognition system" },
        { icon: <FileCheck className="h-5 w-5" />, text: "SIRC compliance" },
      ],
    },
    {
      title: "Sports & Extracurricular Activities",
      icon: <Trophy className="h-12 w-12" />,
      color: "from-[#7A1E1E] to-[#8B2E2E]",
      features: [
        {
          icon: <Trophy className="h-5 w-5" />,
          text: "Inter-hostel sports tournaments",
        },
        {
          icon: <Music className="h-5 w-5" />,
          text: "Cultural festivals & celebrations",
        },
        {
          icon: <Theater className="h-5 w-5" />,
          text: "Performing arts & talent shows",
        },
        {
          icon: <Palette className="h-5 w-5" />,
          text: "Arts, crafts & creativity workshops",
        },
        {
          icon: <Award className="h-5 w-5" />,
          text: "Competition events & awards",
        },
        {
          icon: <PartyPopper className="h-5 w-5" />,
          text: "Traditional & national celebrations",
        },
      ],
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative flex min-h-[70vh] items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={hostelCourtyardBg}
            alt="Education programs"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#7A1E1E]/85 to-[#8B2E2E]/75" />
        </div>

        <div className="z- relative mx-auto mb-10 mt-10 max-w-[1400px] px-4 text-white sm:px-6 lg:px-8">
          <div className="mx-auto max-w-3xl text-center">
            <h1 className="mb-6 text-5xl lg:text-6xl">
              JBF Programs & Initiatives
            </h1>
            <p className="text-2xl leading-relaxed text-gray-100">
              Comprehensive programs designed to transform Jain student hostels
              into centers of excellence, ensuring holistic development and
              well-being.
            </p>
          </div>
        </div>
      </section>

      {/* Programs Grid */}
      <section className="bg-[#FFF9F0] py-12 sm:py-16 lg:py-20 xl:py-24">
        <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
          <div className="space-y-12">
            {programs.map((program, index) => (
              <div
                key={program.title}
                className={`${
                  index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
                } flex flex-col gap-8 overflow-hidden rounded-2xl bg-white shadow-xl lg:flex ${
                  index === 0 ||
                  index === 1 ||
                  index === 2 ||
                  index === 3 ||
                  index === 4
                    ? "relative"
                    : ""
                }`}
              >
                {/* Background Image for First Program (Hostel Modernisation) */}
                {index === 0 && (
                  <div className="absolute inset-0">
                    <img
                      src={hostelCourtyardBg}
                      alt="Hostel courtyard"
                      className="h-full w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-[#7A1E1E]/60 to-[#8B2E2E]/50" />
                  </div>
                )}

                {/* Background Image for Second Program (Student Wellness & Nutrition) */}
                {index === 1 && (
                  <div className="absolute inset-0">
                    <img
                      src={studentDiningBg}
                      alt="Students dining"
                      className="h-full w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-[#D4A017]/80 to-[#B8900F]/75" />
                  </div>
                )}

                {/* Background Image for Third Program (Academic & Career Development) */}
                {index === 2 && (
                  <div className="absolute inset-0">
                    <img
                      src={studentsStudyingBg}
                      alt="Students studying"
                      className="h-full w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-[#7A1E1E]/60 to-[#8B2E2E]/50" />
                  </div>
                )}

                {/* Background Image for Fourth Program (Digital Governance & Transparency) */}
                {index === 3 && (
                  <div className="absolute inset-0">
                    <img
                      src={digitalGovernanceBg}
                      alt="Students with mentor"
                      className="h-full w-full object-cover"
                    />
                    <div className="from-[#D4A017]/92 to-[#B8900F]/88 absolute inset-0 bg-gradient-to-r" />
                  </div>
                )}

                {/* Background Image for Fifth Program (Sports & Extracurricular Activities) */}
                {index === 4 && (
                  <div className="absolute inset-0">
                    <img
                      src={sportsGroundBg}
                      alt="Sports ground"
                      className="h-full w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-[#7A1E1E]/60 to-[#8B2E2E]/50" />
                  </div>
                )}

                {/* Icon & Title Section */}
                <div
                  className={`lg:w-2/5 ${
                    index === 0 ||
                    index === 1 ||
                    index === 2 ||
                    index === 3 ||
                    index === 4
                      ? "relative z-10"
                      : `bg-gradient-to-br ${program.color}`
                  } flex flex-col items-center justify-center p-8 text-center text-white lg:p-12`}
                >
                  <div className="mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
                    {program.icon}
                  </div>
                  <h2 className="text-2xl sm:text-3xl">{program.title}</h2>
                </div>

                {/* Features Section */}
                <div
                  className={`p-8 lg:w-3/5 lg:p-12 ${index === 0 || index === 1 || index === 2 || index === 3 || index === 4 ? "relative z-10 bg-white/95 backdrop-blur-sm" : ""}`}
                >
                  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    {program.features.map(feature => (
                      <div
                        key={feature.text}
                        className="flex items-start gap-3 rounded-lg bg-[#FFF9F0] p-4 transition-all hover:shadow-md"
                      >
                        <div
                          className={`h-10 w-10 bg-gradient-to-br ${program.color} flex flex-shrink-0 items-center justify-center rounded-lg text-white`}
                        >
                          {feature.icon}
                        </div>
                        <p className="pt-2 text-gray-800">{feature.text}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
